import React from 'react';
import logo from './assets/logo-large.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Site Under Construction
        </p>
      </header>
    </div>
  );
}

export default App;
